/**
 * 档案列表页 keep-alive 复用行为：
 * 1) 详情页带 ?refresh=1 返回时，用现有筛选条件重拉当前页（不清筛选）；
 * 2) 关闭本页标签后再打开时，重置筛选并重新加载。
 *
 * 使用方必须实现：
 *   reloadList()     —— 保留筛选，重拉当前页
 *   resetAndReload() —— 重置筛选并重新加载
 */
export default {
  data() {
    return {
      archiveOwnPath: "",
      archiveTagWasOpen: false,
      archiveNeedReset: false
    };
  },
  computed: {
    archiveOpenPaths() {
      return (this.$store.state.tagsView.visitedViews || []).map(v => v.path);
    }
  },
  watch: {
    "$route.query.refresh"(val) {
      if (!val || this.$route.path !== this.archiveOwnPath) {
        return;
      }
      this.reloadList();
      const query = Object.assign({}, this.$route.query);
      delete query.refresh;
      this.$router.replace({ query });
    },
    archiveOpenPaths(paths) {
      const open = paths.indexOf(this.archiveOwnPath) > -1;
      if (this.archiveTagWasOpen && !open) {
        this.archiveNeedReset = true;
      }
      this.archiveTagWasOpen = open;
    }
  },
  created() {
    this.archiveOwnPath = this.$route.path;
    this.archiveTagWasOpen = this.archiveOpenPaths.indexOf(this.archiveOwnPath) > -1;
  },
  activated() {
    if (this.archiveNeedReset) {
      this.archiveNeedReset = false;
      this.resetAndReload();
    }
  }
};
